"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmit = void 0;
var useCache_1 = require("./useCache");
var useNoCache_1 = require("./useNoCache");
var usePagination_1 = require("./usePagination");
var useSubmit = function (onSubmit, options) {
    if (options === void 0) { options = {}; }
    switch (true) {
        case !!options.cacheKey:
            return (0, useCache_1.useCache)(onSubmit, options);
        case !!options.pagination:
            return (0, usePagination_1.usePagination)(onSubmit, options);
        default:
            return (0, useNoCache_1.useNoCache)(onSubmit, options);
    }
};
exports.useSubmit = useSubmit;
//# sourceMappingURL=index.js.map